import { Button, Switch, TextInput, Textarea } from "@mantine/core";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";

const SeasonForm = ({ form, onFinish, submit, update }) => {
  const [values, setValues] = useState({
    name: "", description: "", position: "", releaseDate: "", isEnable: true,
  });

  useEffect(() => {
    if (update) {
      setValues({
        name: update?.name || "",
        description: update?.description || "",
        position: update?.position || "",
        releaseDate: update?.releaseDate
          ? dayjs(update.releaseDate, "DD-MM-YYYY").format("YYYY-MM-DD")
          : "",
        isEnable: update?.isEnable !== undefined ? update.isEnable : true,
      });
    }
  }, [update]);

  const handleChange = (field, value) => setValues((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    onFinish({
      ...values,
      releaseDate: dayjs(values.releaseDate).format("DD-MM-YYYY"),
    });
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
      <TextInput label="Name" required value={values.name} onChange={(e) => handleChange("name", e.target.value)} />
      <Textarea label="Description" required value={values.description} onChange={(e) => handleChange("description", e.target.value)} />
      <TextInput label="Position" type="number" required value={values.position} onChange={(e) => handleChange("position", e.target.value)} />
      <TextInput label="Release Date" type="date" required value={values.releaseDate} onChange={(e) => handleChange("releaseDate", e.target.value)} />
      <Switch label={values.isEnable ? "Enabled" : "Disabled"} checked={values.isEnable} onChange={(e) => handleChange("isEnable", e.currentTarget.checked)} />
      {submit}
    </form>
  );
};

export default SeasonForm;
